import React from 'react';
import { Create, SimpleForm,
    FileInput, FileField, useTranslate } from 'react-admin';

const StudentFileCreate = props => {
  const translate = useTranslate();
  return (
    <Create {...props}>
      <SimpleForm redirect="/players">
        <FileInput source="file" label="resources.players.fields.file" >
          <FileField source="src" title="title" />
        </FileInput>
        <div style={{ width: '100%' }}>
          <lt>
            <li>{translate('resources.student_files.notes.note1')}</li>
            <li>{translate('resources.student_files.notes.note2')}</li>
            <li>{translate('resources.student_files.notes.note3')}</li>
          </lt>
          <pre>
            {translate('resources.players.fields.student_id')},
            {translate('resources.players.fields.last_name')},
            {translate('resources.players.fields.first_name')},
            {translate('resources.players.fields.grade')},
            {translate('resources.players.fields.school_class')},
            {translate('resources.players.fields.lesson_group_ids')}
            ({translate('resources.student_files.notes.multi')})
          </pre>
        </div>
      </SimpleForm>
    </Create>
  );
};

export default {
  create: StudentFileCreate,
};
